/* Presentation only: never changes the composition model, renderer or pricing. */
(() => {
  function enhance(root) {
    if (root.dataset.guided || !root.ready) return;
    const form = root.querySelector('[data-controls]');
    const steps = [...form.querySelectorAll('.la-step')];
    if (steps.length !== 3) return;
    root.dataset.guided = 'true';
    const he = root.locale === 'he';
    const text = (en, heb) => he ? heb : en;
    const button = (label, action) => {
      const el = document.createElement('button'); el.type = 'button';
      el.textContent = label; el.addEventListener('click', action); return el;
    };
    let current = 0, editingSlot = 0, furthest = 0;
    const progress = document.createElement('nav');
    progress.className = 'ls-progress'; progress.setAttribute('aria-label', text('Build your piece', 'שלבי בניית התכשיט'));
    const labels = [text('Gold', 'גוון הזהב'), text('Medallions', 'מספר מדליונים'), text('Your symbols', 'הסמלים שלך')];
    const links = labels.map((label, i) => {
      const b = button(`${i + 1} · ${label}`, () => show(i, true)); progress.append(b); return b;
    });
    form.prepend(progress);
    const stepHeading = document.createElement('p'); stepHeading.className = 'ls-step-heading';
    stepHeading.setAttribute('role', 'status'); progress.after(stepHeading);
    const actions = document.createElement('div'); actions.className = 'ls-actions';
    const back = button(text('Back', 'חזרה'), () => show(current - 1, true));
    const next = button('', () => show(current + 1, true)); next.className = 'ls-next';
    actions.append(back, next); steps[2].after(actions);
    const buy = root.querySelector('[data-buy]');
    const summary = root.querySelector('[data-order-summary]');
    const compact = document.createElement('p'); compact.className = 'ls-purchase-summary';
    compact.hidden = true; buy.before(compact);
    function updateCompletion() {
      const gold = {'Yellow Gold':'זהב צהוב','Rose Gold':'זהב ורוד','White Gold':'זהב לבן'};
      const parts = [he ? gold[root.state.gold] : root.state.gold, text(`${root.state.count} medallions`, `${root.state.count} מדליונים`)];
      root.state.slots.slice(0, root.state.count).forEach((slot, i) => {
        if (slot.symbol === 'initial' || slot.symbol === 'heart') {
          const letters = slot.symbol === 'heart' ? slot.heart : slot.initial;
          parts.push(text(`Medallion ${i + 1}${slot.symbol === 'heart' ? ' reverse' : ''}: `, `מדליון ${i + 1}${slot.symbol === 'heart' ? ' בגב' : ''}: `) + (letters || text('Choose initials', 'יש לבחור אותיות')));
        }
      });
      compact.textContent = parts.join(' · '); compact.hidden = current !== 2;
    }
    ['click','change','input'].forEach(type => root.addEventListener(type, () => queueMicrotask(updateCompletion)));
    const title = document.createElement('header'); title.className = 'ls-title';
    title.append(root.querySelector('.la-heading'), root.querySelector('.la-intro'));
    root.querySelector('.la-grid').before(title);
    function show(index, focus) {
      current = Math.max(0, Math.min(2, index)); furthest = Math.max(furthest, current);
      steps.forEach((s, i) => s.hidden = i !== current);
      links.forEach((b, i) => {
        b.setAttribute('aria-current', i === current ? 'step' : 'false');
        b.dataset.complete = String(i < furthest && i !== current);
        b.textContent = `${i < furthest && i !== current ? '✓' : i + 1} · ${labels[i]}`;
      });
      stepHeading.textContent = text(`Step ${current + 1} of 3 — ${labels[current]}`, `שלב ${current + 1} מתוך 3 — ${labels[current]}`);
      back.hidden = current === 0; next.hidden = current === 2;
      actions.hidden = current === 2;
      next.textContent = current === 0 ? text('Continue to medallions', 'המשך לבחירת הכמות') : text('Continue to your symbols', 'המשך לבחירת הסמלים');
      buy.hidden = current !== 2; summary.hidden = true;
      updateCompletion();
      root.dataset.buildStep = String(current + 1);
      showPhoto(-1);
      if (focus) {
        const target = steps[current]; target.tabIndex = -1; target.focus({preventScroll:true});
        // Explicit Next/Back brings the stage below the header. Account for a
        // pinned gallery only when one actually exists; mobile is in normal flow.
        requestAnimationFrame(() => {
          const gallery = root.querySelector('.la-gallery');
          const mobile = matchMedia('(max-width:760px)').matches;
          const pinned = ['sticky', 'fixed'].includes(getComputedStyle(gallery).position);
          const offset = mobile && pinned ? gallery.getBoundingClientRect().height + (parseFloat(getComputedStyle(gallery).top) || 0) + 12 : (document.querySelector('.hd-header')?.getBoundingClientRect().height || 0) + 20;
          const delta = stepHeading.getBoundingClientRect().top - offset;
          if (Math.abs(delta) > 24) window.scrollBy({top:delta,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        });
      }
    }
    // Keep the original preview DOM intact; reference photography shares its frame.
    const picture = root.querySelector('.la-picture');
    const photo = document.createElement('button'); photo.className = 'ls-photo'; photo.hidden = true;
    photo.type = 'button'; photo.setAttribute('aria-label', text('Enlarge styling photo', 'הגדלת תמונת הענידה'));
    const photoImage = document.createElement('img'); photo.append(photoImage); picture.after(photo);
    const lifestyle = root.querySelector('.la-lifestyle');
    const originals = [...lifestyle.querySelectorAll('[data-lifestyle]')];
    const strip = document.createElement('div'); strip.className = 'ls-gallery-strip';
    strip.setAttribute('aria-label', text('Product gallery', 'גלריית התכשיט'));
    const previewButton = button(text('Your design', 'העיצוב שלך'), () => showPhoto(-1)); strip.append(previewButton);
    const thumbs = originals.map((original, i) => {
      const b = button('', () => showPhoto(i));
      b.setAttribute('aria-label', original.getAttribute('aria-label'));
      const img = original.querySelector('img').cloneNode(); img.loading = 'lazy'; b.append(img); strip.append(b); return b;
    });
    const reference = document.createElement('p'); reference.className = 'la-caption ls-reference';
    reference.textContent = lifestyle.querySelector(':scope > p').textContent;
    lifestyle.hidden = true;
    root.querySelector('.la-gallery').append(strip, reference);
    let selectedPhoto = -1;
    const frame = document.createElement('div'); frame.className = 'ls-gallery-frame';
    picture.before(frame); frame.append(picture, photo);
    function advancePhoto(delta) {
      const length = originals.length + 1;
      showPhoto(((selectedPhoto + 1 + delta + length) % length) - 1);
    }
    const previousPhoto = button(he ? '›' : '‹', () => advancePhoto(-1));
    const nextPhoto = button(he ? '‹' : '›', () => advancePhoto(1));
    previousPhoto.className = 'ls-gallery-arrow ls-gallery-previous';
    nextPhoto.className = 'ls-gallery-arrow ls-gallery-next';
    previousPhoto.setAttribute('aria-label', text('Previous image', 'התמונה הקודמת'));
    nextPhoto.setAttribute('aria-label', text('Next image', 'התמונה הבאה'));
    frame.append(previousPhoto, nextPhoto);
    function showPhoto(index) {
      selectedPhoto = index; picture.hidden = index !== -1; photo.hidden = index === -1;
      root.dataset.galleryMode = index === -1 ? 'design' : 'photo';
      root.querySelector('.la-gallery-nav').hidden = index !== -1;
      reference.hidden = index === -1;
      previewButton.setAttribute('aria-pressed', String(index === -1));
      thumbs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
      if (index >= 0) { const src = originals[index].querySelector('img'); photoImage.src = src.src; photoImage.alt = src.alt; }
    }
    photo.addEventListener('click', () => originals[selectedPhoto]?.click());
    let swipeStart = null, swiped = false;
    [picture, photo].forEach(surface => {
      surface.addEventListener('pointerdown', event => { swipeStart = [event.clientX, event.clientY]; swiped = false; });
      surface.addEventListener('pointerup', event => {
        if (!swipeStart) return;
        const dx = event.clientX - swipeStart[0], dy = event.clientY - swipeStart[1]; swipeStart = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        swiped = true;
        advancePhoto((dx < 0 ? 1 : -1) * (he ? -1 : 1));
      });
      surface.addEventListener('click', event => {
        if (swiped) { event.preventDefault(); event.stopImmediatePropagation(); swiped = false; }
      }, true);
    });
    // Return to live composition after any build choice; no scrolling or auto-advance.
    root.addEventListener('click', event => {
      if (event.target.closest('[data-gold],[data-count],[data-choice],[data-slot]')) showPhoto(-1);
    });
    root.addEventListener('change', () => showPhoto(-1));
    // Native validation must never target a field inside a hidden step.
    let validating = false;
    form.addEventListener('invalid', event => {
      event.preventDefault();
      if (validating) return;
      validating = true;
      show(2, false);
      editingSlot = Number(event.target.dataset.initial ?? event.target.dataset.heartSlot ?? 0);
      updatePersonalization();
      const field = event.target;
      root.validationError = true;
      root.querySelector('[data-status]').textContent = text(`Please choose the letters for medallion ${editingSlot + 1}.`, `יש לבחור את האותיות למדליון ${editingSlot + 1}.`);
      setTimeout(() => { field.focus(); validating = false; }, 0);
    }, true);
    form.addEventListener('submit', event => {
      if (current < 2) { event.preventDefault(); event.stopImmediatePropagation(); show(current + 1, true); }
    }, true);
    const note = document.createElement('p'); note.className = 'ls-count-note'; note.setAttribute('role', 'status');
    steps[1].append(note);
    root.addEventListener('click', event => {
      const b = event.target.closest('[data-count]');
      if (b) note.textContent = Number(b.dataset.count) < 5 ? text('Only the selected number is included. Other positions are kept if you increase the number again.', 'רק מספר המדליונים שנבחר ייכלל בהזמנה. הבחירות במקומות הנוספים נשמרות אם מגדילים שוב את הכמות.') : '';
    });
    // Only the currently edited medallion exposes its personal fields.
    const personal = root.querySelector('[data-personalization]');
    const lengths = new Map();
    function updatePersonalization() {
      [...personal.children].forEach(panel => {
        const field = panel.querySelector('[data-initial],[data-heart-slot]');
        if (!field) return;
        const index = Number(field.dataset.initial ?? field.dataset.heartSlot);
        panel.hidden = index !== editingSlot;
        if (field.dataset.heartSlot === undefined) return;
        const fields = [...panel.querySelectorAll('[data-heart-slot]')];
        const populated = fields.reduce((n, f, i) => f.value ? i + 1 : n, 1);
        const count = Math.max(lengths.get(index) || 1, populated);
        let control = panel.querySelector('[data-letter-count]');
        if (!control) {
          const label = document.createElement('label'); label.className = 'ls-letter-count';
          label.append(document.createTextNode(text('Number of initials', 'מספר האותיות')));
          control = document.createElement('select'); control.dataset.letterCount = String(index);
          control.setAttribute('aria-label', text(`Number of initials for medallion ${index + 1}`, `מספר האותיות במדליון ${index + 1}`));
          [1,2,3,4].forEach(n => { const option = document.createElement('option'); option.value = n; option.textContent = n; control.append(option); });
          label.append(control); panel.querySelector('.la-heart-letters').before(label);
          control.addEventListener('change', () => {
            const n = Number(control.value); lengths.set(index, n);
            fields.forEach((f, i) => {
              if (i >= n && f.value) { f.value = ''; f.dispatchEvent(new Event('change', {bubbles:true})); }
              f.required = i < n; f.parentElement.hidden = i >= n;
              if (f.options[0]?.value === '') f.options[0].textContent = i < n ? text('Choose', 'בחרי') : text('None', 'ללא');
            });
          });
          const help = panel.querySelector(':scope > span');
          if (help) help.textContent = text('Initials on the reverse, in the order selected.', 'האותיות בגב המדליון, לפי הסדר שנבחר.');
        }
        control.value = count;
        fields.forEach((f, i) => {
          f.required = i < count; f.parentElement.hidden = i >= count;
          if (f.options[0]?.value === '') f.options[0].textContent = i < count ? text('Choose', 'בחרי') : text('None', 'ללא');
        });
      });
    }
    new MutationObserver(updatePersonalization).observe(personal, {childList:true});
    root.addEventListener('click', event => {
      const slot = event.target.closest('[data-slot]');
      if (slot) editingSlot = Number(slot.dataset.slot);
      updatePersonalization();
    });
    updatePersonalization();
    show(0, false);
  }
  function init() { document.querySelectorAll('lucky-atelier').forEach(enhance); }
  customElements.whenDefined('lucky-atelier').then(init);
  document.addEventListener('shopify:section:load', init);
})();
